import $ from '@common/Scripts/libs/jquery-1.12.4.min.js';
import '@common/Scripts/libs/jquery.history.js';

/**
 * Constants for Diff Maps
 */
var valueCreated = 'created',
	valueUpdated = 'updated',
	valueDeleted = 'deleted',
	valueUnchanged = 'unchanged';

var langs = {
	en: '/en',
	ru: '/ru'
};

var diff = (function () {
	return {
		map: function (obj1, obj2) {
			if ($.isFunction(obj1) || $.isFunction(obj2)) {
				throw 'Invalid argument. Function given, object expected.';
			}

			if (!(($.isPlainObject(obj1) || $.isArray(obj1)) && ($.isPlainObject(obj2) || $.isArray(obj2)))) {
				return {
					type: this.compareValues(obj1, obj2),
					oldValue: obj1,
					value: obj2
				};
			}

			var changed = false,
				diff = {},
				key;
			for (key in obj1) {
				key = key.toLowerCase();
				if (Object.prototype.hasOwnProperty.call(obj1, key)) {
					if ($.isFunction(obj1[key])) {
						continue;
					}

					var value2 = undefined;
					if (typeof obj2[key] !== 'undefined') {
						value2 = obj2[key];
					}

					diff[key] = this.map(obj1[key], value2);
					changed = changed || diff[key].type != valueUnchanged;
				}
			}

			for (key in obj2) if (Object.prototype.hasOwnProperty.call(obj2, key)) {
				key = key.toLowerCase();
				if ($.isFunction(obj2[key]) || typeof diff[key] !== 'undefined') {
					continue;
				}

				diff[key] = this.map(undefined, obj2[key]);
				changed = changed || diff[key].type != valueUnchanged;
			}

			return {
				diff: diff,
				changed: changed
			};
		},
		compareValues: function (value1, value2) {
			if ((value1 + '').toLowerCase() === (value2 + '').toLowerCase()) {
				return valueUnchanged;
			}

			if (typeof value1 === 'undefined') {
				return valueCreated;
			}

			if (typeof value2 === 'undefined') {
				return valueDeleted;
			}

			return valueUpdated;
		}
	};
})();

var url = (nodejs ? global : window).url = (function (urlApi, $) {
	var api, apiIsNative;

	if (nodejs) {
		api = null;
	} else {
		if (typeof History.init === 'undefined') {
			api = history;
			apiIsNative = true;
		} else {
			api = History;
			apiIsNative = false;
		}
	}

	var createState = function () {
		return {
			histories: [location.href],
			historiesIndex: 0,
			subscribersIdCounter: 0,
			subscribers: [],
			dontEvaluateState: false,
			dontPushState: false,
			dontUpdateStateParameters: false,
			stateSearch: {},
			stateHash: {},
			statePath: [],
			goingBack: false,
			goingForward: false
		};
	};
	var browserState = nodejs ? null : createState();
	var getState = nodejs
		? function () {
			var context = global.__legacyWebpackGetRenderContext();
			context.urlState = context.urlState || createState();
			return context.urlState;
		}
		: function () {
			return browserState;
		};
	var state = nodejs
		? new Proxy({}, {
			get: function (_, property) {
				return getState()[property];
			},
			set: function (_, property, value) {
				getState()[property] = value;
				return true;
			}
		})
		: browserState;

	Object.defineProperty(urlApi, 'goingBack', {
		get: function () {
			return state.goingBack;
		},
		set: function (value) {
			state.goingBack = value;
		}
	});
	Object.defineProperty(urlApi, 'goingForward', {
		get: function () {
			return state.goingForward;
		},
		set: function (value) {
			state.goingForward = value;
		}
	});

	/**
	 * @function
	 * serialize key-value object to string
	 *
	 * @param {object} source
	 * @param {string} starter - start symbol ("?" for search and "#" for hash)
	 * @param {string} separator - separator symbol ("&" for search and ";" for hash)
	 *
	 * @returns {string}
	 */
	var serialize = function (source, starter, separator) {
		var serializedData = '';
		for (var key in source) if (Object.prototype.hasOwnProperty.call(source, key)) {
			key = key.toLowerCase();
			var value = source[key];

			if (typeof value !== 'undefined' && value !== null) {
				if (serializedData.length) {
					serializedData += separator;
				}

				if ($.isArray(value)) {
					var j, n = value.length;

					for (j = 0; j < n; ++j) {
						serializedData += key + '[' + j + ']=' + encodeURIComponent(value[j]);
					}
				} else {
					serializedData += value !== '' ? key + '=' + encodeURIComponent(value) : key;
				}
			}
		}

		return serializedData ? starter + serializedData : '';
	};

	/**
	 * @function
	 * handle event
	 *
	 * @param {event} event
	 */
	var handleStateEvent = function (event) {
		var href = location.href,
			data = event.data || {},
			oldState = urlApi.decompose(state.histories[state.historiesIndex]),
			oldStatePath = oldState.path,
			oldStateSearch = oldState.search,
			oldStateHash = oldState.hash,
			pathChanged = false;

		/**
		 * Not necessary to update state parameters if change of one of them initiated popstate
		 */
		if (!state.dontUpdateStateParameters) {
			state.statePath = urlApi.parseUrlPath();
			state.stateSearch = urlApi.parseUrlSearch();
			state.stateHash = urlApi.parseUrlHash();
		}

		/**
		 * Set flags to indicate which parts of url have been changed
		 */
		if (oldStatePath.length !== state.statePath.length) {
			pathChanged = true;
		}

		if (!pathChanged) {
			var n = Math.max(oldStatePath.length, state.statePath.length);

			for (var i = 0; i < n; ++i) {
				if (oldStatePath[i] !== state.statePath[i]) {
					pathChanged = true;
					break;
				}
			}
		}

		var searchDiffMap = diff.map(oldStateSearch, state.stateSearch),
			hashDiffMap = diff.map(oldStateHash, state.stateHash),
			/**
			 * Store diff of url state to use in event handlers
			 */
			info = {
				// Diff object of search
				search: searchDiffMap.diff,

				// Diff object of hash
				hash: hashDiffMap.diff,

				// Diff object of path
				path: {
					changed: pathChanged,
					value: state.statePath
				}
			};

		if (!pathChanged && !searchDiffMap.changed && !hashDiffMap.changed) {
			return;
		}

		/**
		 * Not necessary to go further if only replace required
		 */
		if (state.dontPushState) {
			state.histories[state.historiesIndex] = href;
		} else {
			if (!state.dontEvaluateState) {
				if (href === state.histories[state.historiesIndex - 1]) {
					/**
					 * If going back let user to go back
					 */
					--state.historiesIndex;

					url.goingBack = true;
				} else if (href === state.histories[state.historiesIndex + 1]) {
					/**
					 * If going forward let user to go forward
					 */
					++state.historiesIndex;

					url.goingForward = true;
				} else if (href !== state.histories[state.historiesIndex]) {
					/**
					 * If going to new path let user to visit new path
					 */
					state.histories[++state.historiesIndex] = href;

					/**
					 * Cut unreachable histories branch
					 */
					state.histories.splice(state.historiesIndex + 1, state.histories.length);
				}

				/**
				 * Iterate through subscribers
				 */
				var ns = state.subscribers.length,
					subscribersCopy = state.subscribers.slice(),
					j;

				for (j = 0; j < ns; ++j) {
					var subscriberObject = subscribersCopy[j];

					if (typeof subscriberObject !== 'undefined') {
						if (subscriberObject.type === 'full') {
							subscriberObject.callback(data, info);
						} else if (subscriberObject.type === 'search' || subscriberObject.type === 'hash') {
							var targetDiff = subscriberObject.type === 'search' ? searchDiffMap : hashDiffMap,
								targetDiffMap = targetDiff.diff,
								somethingChanged = false,
								keyNotApplied = true;

							if (typeof subscriberObject.key === 'string') {
								var entry = targetDiffMap[subscriberObject.key];

								somethingChanged = typeof entry !== 'undefined' && entry.type !== valueUnchanged;
								keyNotApplied = false;
							}

							if ($.isArray(subscriberObject.keys)) {
								var keys = subscriberObject.keys,
									keysLength = keys.length;

								for (var k = 0; k < keysLength; ++k) {
									var itemEntry = targetDiffMap[keys[k]];

									if (typeof itemEntry !== 'undefined' && itemEntry.type !== valueUnchanged) {
										somethingChanged = true;
										break;
									}
								}
								keyNotApplied = false;
							}

							if (keyNotApplied) {
								// if I'm here my subscriber observe all key in search or hash
								somethingChanged = targetDiff.changed;
							}

							if (somethingChanged) {
								subscriberObject.callback(data, info);
							}
						} else {
							subscriberObject.callback(data, info);
						}
					}
				}
			}

			url.goingForward = false;
			url.goingBack = false;

			if (!apiIsNative) {
				api.busy(false);
			}
		}
	};

	/**
	 * @method
	 * get current state hash serialized into string
	 * testable
	 *
	 * @returns {string}
	 */
	var serializeStateHash = urlApi.serializeStateHash = function (hash) {
		if (typeof hash === 'undefined') {
			hash = state.stateHash;
		}

		return serialize(hash, '#', ';');
	};

	/**
	 * @method
	 * get current state search serialized into string
	 * testable
	 *
	 * @returns {string}
	 */
	var serializeStateSearch = urlApi.serializeStateSearch = function (search) {
		if (typeof search === 'undefined') {
			search = state.stateSearch;
		}

		return serialize(search, '?', '&');
	};

	/**
	 * @method
	 * get current state path serialized into string
	 * testable
	 *
	 * @returns {string}
	 */
	var serializeStatePath = urlApi.serializeStatePath = function (path) {
		var ignoreLang = false;

		if (path === true) {
			ignoreLang = true;
			path = undefined;
		}

		if (typeof path === 'undefined') {
			path = state.statePath;
		}

		var result = '',
			n = path ? path.length : 0,
			i;

		for (i = 0; i < n; ++i) {
			if (!ignoreLang || !langs[path[i]]) {
				result += '/' + path[i];
			}
		}

		return result;
	};

	/**
	 * @method
	 * get current state serialized into string
	 * testable
	 *
	 * @returns {string}
	 */
	var serializeState = urlApi.serializeState = function (stateObject) {
		stateObject = stateObject ||
			{
				path: state.statePath,
				search: state.stateSearch,
				hash: state.stateHash
			};

		return serializeStatePath(stateObject.path) +
			serializeStateSearch(stateObject.search) +
			serializeStateHash(stateObject.hash);
	};

	/**
	 * @method
	 * get current state hash
	 * testable
	 *
	 * @param {string} key
	 *
	 * @returns {object} state hash as key-value object
	 */
	urlApi.getStateHash = function (key) {
		key = typeof key == 'string' ? key.toLowerCase() : key;
		return state.stateHash[key];
	};

	/**
	 * @method
	 * get current state search
	 * testable
	 *
	 * @param {string} key
	 *
	 * @returns {object} state search as key-value object
	 */
	urlApi.getStateSearch = function (key) {
		key = typeof key == 'string' ? key.toLowerCase() : key;
		return state.stateSearch[key];
	};

	/**
	 * @method
	 * get current state hash or search
	 *
	 * @param {string} type
	 * @param {string} key
	 *
	 * @returns {object} state hash or search as key-value object
	 */
	urlApi.getStateType = function (type, key) {
		key = typeof key == 'string' ? key.toLowerCase() : key;
		return type === 'hash' ? state.stateHash[key] : type === 'search' ? state.stateSearch[key] : null;
	};

	/**
	 * @method
	 * get current state path
	 * testable
	 *
	 * @returns {array} state path splitted on entries
	 */
	urlApi.getStatePath = function () {
		return state.statePath;
	};

	/**
	 * @method
	 * get history of url changes
	 * testable
	 *
	 * @returns {array} history of url changes as array of urls
	 */
	urlApi.getHistories = function () {
		return state.histories;
	};

	/**
	 * @method
	 * get index of current state in history of url changes
	 * testable
	 *
	 * @returns {number}
	 */
	urlApi.getHistoriesIndex = function () {
		return state.historiesIndex;
	};

	/**
	 * @method
	 * parse string to key-value object
	 *
	 * @param {string} source
	 * @param {string} splitter
	 *
	 * @returns {array} state path splitted on entries
	 */
	var parse = urlApi.parse = function (source, splitter) {
		var indexPattern = /\[(\d+)\]/,
			parameters = {},
			pairs = (source || '').split(splitter),
			n = pairs.length,
			i;

		for (i = 0; i < n; ++i) {
			var pair = pairs[i];

			if (pair !== '') {
				var eqIndex = pair.indexOf('='),
					key = eqIndex >= 0 ? pair.substr(0, eqIndex) : pair,
					value = eqIndex >= 0 ? pair.substr(eqIndex + 1) : 0;

				key = key.toLowerCase();
				if (indexPattern.test(key)) {
					var index = parseInt(indexPattern.exec(key)[1]),
						parameter = key.split('[')[0];

					parameters[parameter] = parameters[parameter] || [];
					parameters[parameter][index] = decodeURIComponent(value || '');
				} else {
					parameters[key] = parameters[key] || decodeURIComponent(value || '');
				}
			}
		}

		return parameters;
	};

	/**
	 * @method
	 * parse current location hash string to key-value object
	 * testable
	 */
	urlApi.parseUrlHash = function () {
		return parse(location.hash.slice(1), ';');
	};

	/**
	 * @method
	 * parse current location search string to key-value object
	 * testable
	 */
	urlApi.parseUrlSearch = function () {
		return parse(location.search.slice(1), '&');
	};

	/**
	 * @method
	 * parse current location path string to array of entries
	 * testable
	 */
	urlApi.parseUrlPath = function () {
		return location.pathname.slice(1).split('/');
	};

	/**
	 * @method
	 * parse current location parameters and update current state with them
	 */
	var updateState = urlApi.updateState = function () {
		state.stateSearch = urlApi.parseUrlSearch();
		state.stateHash = urlApi.parseUrlHash();
		state.statePath = urlApi.parseUrlPath();
	};

	/**
	 * Object, containing parameters for subscription
	 * @typedef  {object} subscriptionOptions
	 * @property {('full'|'search'|'hash')} [type] - indicates to which types of url changes subscription refers
	 * @property {string}                   [key]  - (only for type 'search' or 'hash') indicates to which key subscription refers
	 * @property {Array<string>}            [keys] - (only for type 'search' or 'hash') indicates to which key subscription refers
	 * @property {string}                   [id]   - unique subscription id
	 */

	/**
	 * @method
	 * subscribe to url changes
	 * testable
	 *
	 * @param {subscriptionOptions} [options] - options for subscription
	 * @param {function} callback - function which will be called when url changes
	 *
	 * @returns
	 */
	urlApi.subscribe = function (options, callback) {
		if (nodejs) {
			return;
		}

		if (typeof options === 'function') {
			callback = options;
			options = {};
		} else if (options === null || typeof options === 'undefined') {
			throw new Error('subscribe(): invalid call');
		}

		var id = options.id;

		if (typeof id !== 'undefined') {
			var n = state.subscribers.length,
				i;

			for (i = 0; i < n; ++i) {
				if (state.subscribers[i].id === id) {
					urlApi.unsubscribe(id);
					break;
				}
			}
		}

		id = id || ++state.subscribersIdCounter;

		options.key = typeof options.key == 'string' ? options.key.toLowerCase() : options.key;
		if ($.isArray(options.keys)) {
			for (var i = 0; i < options.keys.length; i++) {
				options.keys[i] = typeof options.keys[i] == 'string' ? options.keys[i].toLowerCase() : options.keys[i];
			}
		}

		var subscriberObject = {
			type: options.type,
			key: options.key,
			keys: options.keys,
			id: id,
			callback: callback
		};

		state.subscribers.push(subscriberObject);

		return id;
	};

	/**
	 * @method
	 * unsubscribe from url changes
	 * testable
	 *
	 * @param {string} targetId - id of target object
	 */
	urlApi.unsubscribe = function (targetId) {
		var n = state.subscribers.length,
			i;

		for (i = 0; i < n; ++i) {
			var subscriberObject = state.subscribers[i];

			if (subscriberObject.id === targetId) {
				state.subscribers.remove(i);

				break;
			}
		}

		return null;
	};

	/**
	 * @method
	 * replace or push current url
	 * testable
	 *
	 * @param {object} stateData
	 * @param {string} stateTitle
	 * @param {string} stateUrl
	 * @param {"replace"|"push"}
	 */
	var stateAction = urlApi.stateAction = function (stateData, stateTitle, stateUrl, action) {
		var windowPath = nodejs
			? global.path
			: window.path;

		if (windowPath &&
			windowPath !== '/' &&
			stateUrl &&
			stateUrl[0] === '/' &&
			stateUrl.indexOf(windowPath) !== 0) {
			stateUrl = windowPath + stateUrl.substr(1);
		}

		if (action === 'replace') {
			state.dontPushState = true;
		}

		if (stateData && stateData.ignore) {
			delete stateData.ignore;

			state.dontEvaluateState = true;
		}

		if (stateTitle !== null && typeof stateTitle !== 'undefined') {
			document.title = stateTitle;
		} else {
			stateTitle = document.title;
		}

		if (action === 'replace') {
			api.replaceState(stateData, stateTitle, stateUrl);
		} else if (action === 'push') {
			api.pushState(stateData, stateTitle, stateUrl);
		} else {
			throw new Error('stateAction: invalid call');
		}

		if (apiIsNative) {
			handleStateEvent({ data: stateData });
		}

		if (state.dontEvaluateState) {
			state.dontEvaluateState = false;
		}

		if (action === 'replace') {
			state.dontPushState = false;
		}
	};

	/**
	 * @method
	 * replace current url
	 * testable
	 *
	 * @param {object} stateData
	 * @param {string} stateTitle
	 * @param {string} stateUrl
	 */
	urlApi.replaceState = function (stateData, stateTitle, stateUrl) {
		stateAction(stateData, stateTitle, stateUrl, 'replace');
	};

	/**
	 * @method
	 * push new url
	 * testable
	 *
	 * @param {object} stateData
	 * @param {string} stateTitle
	 * @param {string} stateUrl
	 */
	urlApi.pushState = function (stateData, stateTitle, stateUrl) {
		if (stateData) {
			var index;

			if (stateData.preserveStateSearch) {
				var searchToInsert = url.serializeStateSearch();

				if (searchToInsert.indexOf('?') > -1 && stateUrl.indexOf('?') > -1)
					searchToInsert = searchToInsert.replace(/\?/g, '&');

				index = stateUrl.indexOf('#');

				if (index > -1) {
					var oldHash = url.serializeStateHash();
					stateUrl = stateUrl.slice(0, index) + searchToInsert + '#' + stateUrl.substring(index + 1) + (oldHash.length > 0 ? ';' + oldHash.slice(1) : '');
				} else {
					stateUrl += searchToInsert;
				}
			}

			if (stateData.preserveStateHash) {
				index = stateUrl.indexOf('#');

				if (index > -1) {
					stateUrl = stateUrl.slice(0, index) + url.serializeStateHash();
				} else {
					stateUrl += url.serializeStateHash();
				}
			}

			stateUrl = serializeState(urlApi.decompose(stateUrl));
		}

		stateAction(stateData, stateTitle, stateUrl, 'push');
	};

	/**
	 * @method
	 * replace/push value in url hash/search key-value pair
	 * testable
	 *
	 * @param {object} stateData
	 * @param {string} key
	 * @param {string} value
	 * @param {"replace"|"push"} action
	 * @param {"hash"|"search"}  type
	 */
	var stateActionType = urlApi.stateActionType = function (stateData, key, value, action, type) {
		var object;

		if (type === 'hash') {
			object = state.stateHash;
		} else if (type === 'search') {
			object = state.stateSearch;
		} else {
			throw new Error('stateActionType: invalid call');
		}

		if (key && typeof key === 'object' && !$.isArray(value)) {
			for (var currentKey in key) if (Object.prototype.hasOwnProperty.call(key, currentKey)) {
				var current = { key: currentKey.toLowerCase(), value: key[currentKey] };
				object[current.key] = current.value !== null ? '' + current.value : undefined;
			}
		} else {
			key = typeof key == 'string' ? key.toLowerCase() : key;
			if (value !== null && !$.isArray(value)) {
				object[key] = '' + value;
			} else {
				object[key] = undefined;
			}
		}

		var newSerializedState = serializeState();

		state.dontUpdateStateParameters = true;

		stateAction(stateData, document.title, newSerializedState, action);

		state.dontUpdateStateParameters = false;
	};

	/**
	 * @method
	 * replace/push value in url hash/search key-value pair
	 * testable
	 *
	 * @param {object} stateData
	 * @param {object} parameters
	 * @param {"replace"|"push"} action
	 */
	urlApi.stateActionMultitype = function (stateData, parameters, action) {
		for (var type in parameters) if (Object.prototype.hasOwnProperty.call(parameters, type)) {
			var object;

			if (type === 'hash') {
				object = state.stateHash;
			} else if (type === 'search') {
				object = state.stateSearch;
			} else {
				throw new Error('stateActionType: invalid call');
			}

			var subparameters = parameters[type];

			for (var key in subparameters) if (Object.prototype.hasOwnProperty.call(subparameters, key)) {
				var value = subparameters[key];
				key = key.toLowerCase();
				if (value !== null && !$.isArray(value)) {
					object[key] = '' + value;
				} else {
					object[key] = undefined;
				}
			}
		}

		var newSerializedState = serializeState();

		state.dontUpdateStateParameters = true;

		stateAction(stateData, document.title, newSerializedState, action);

		state.dontUpdateStateParameters = false;
	};

	/**
	 * @method
	 * replace value in url hash key-value pair
	 * testable
	 *
	 * @param {object} stateData
	 * @param {string} key
	 * @param {string} value
	 */
	urlApi.replaceStateHash = function (stateData, key, value) {
		stateActionType(stateData, key, value, 'replace', 'hash');
	};

	/**
	 * @method
	 * push new url with new value in url hash key-value pair
	 * testable
	 *
	 * @param {object} stateData
	 * @param {string} key
	 * @param {string} value
	 */
	urlApi.pushStateHash = function (stateData, key, value) {
		stateActionType(stateData, key, value, 'push', 'hash');
	};

	/**
	 * @method
	 * replace value in url search key-value pair
	 * testable
	 *
	 * @param {object} stateData
	 * @param {string} key
	 * @param {string} value
	 */
	urlApi.replaceStateSearch = function (stateData, key, value) {
		stateActionType(stateData, key, value, 'replace', 'search');
	};

	/**
	 * @method
	 * push new url with new value in url search key-value pair
	 * testable
	 *
	 * @param {object} stateData
	 * @param {string} key
	 * @param {string} value
	 */
	urlApi.pushStateSearch = function (stateData, key, value) {
		stateActionType(stateData, key, value, 'push', 'search');
	};

	/**
	 * @method
	 * emit go back through url history
	 */
	urlApi.back = function () {
		state.dontPushState = true;
		state.dontEvaluateState = true;

		api.back();

		state.dontPushState = false;
		state.dontEvaluateState = false;
	};

	/**
	 * @method
	 * emit go forward through url history
	 */
	urlApi.forward = function () {
		state.dontPushState = true;
		state.dontEvaluateState = true;

		api.forward();

		state.dontPushState = false;
		state.dontEvaluateState = false;
	};

	/**
	 * @method
	 * convert url string to object with path string and search and hash key-value objects
	 */
	urlApi.decompose = function (string) {
		return {
			path: string.replace(/[?#].*/, '').replace(/(.*\/\/[^/]*\/)|(^\/)|(\/$)/, '').split('/'),
			search: string.indexOf('?') > 0 ? parse(string.replace(/.*\?([^#]*)(.*)/, '$1'), '&') : {},
			hash: string.indexOf('#') > 0 ? parse(string.replace(/.*#/, ''), ';') : {}
		};
	};

	updateState();

	if (!nodejs) {
		$(window).bind('popstate', handleStateEvent);

		urlApi.getOrigin = function () {
			var location = window.location;

			if (!location.origin) {
				location.origin = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
			}

			return location.origin;
		};
	}

	return urlApi;
})({}, $);

// Keep the default API object and named api so callers can use either
// whole-module or tree-shakeable ESM imports.
var back = url.back,
	decompose = url.decompose,
	forward = url.forward,
	getHistories = url.getHistories,
	getHistoriesIndex = url.getHistoriesIndex,
	getOrigin = url.getOrigin,
	getStateHash = url.getStateHash,
	getStatePath = url.getStatePath,
	getStateSearch = url.getStateSearch,
	getStateType = url.getStateType,
	parse = url.parse,
	parseUrlHash = url.parseUrlHash,
	parseUrlPath = url.parseUrlPath,
	parseUrlSearch = url.parseUrlSearch,
	pushState = url.pushState,
	pushStateHash = url.pushStateHash,
	pushStateSearch = url.pushStateSearch,
	replaceState = url.replaceState,
	replaceStateHash = url.replaceStateHash,
	replaceStateSearch = url.replaceStateSearch,
	serializeState = url.serializeState,
	serializeStateHash = url.serializeStateHash,
	serializeStatePath = url.serializeStatePath,
	serializeStateSearch = url.serializeStateSearch,
	stateAction = url.stateAction,
	stateActionMultitype = url.stateActionMultitype,
	stateActionType = url.stateActionType,
	subscribe = url.subscribe,
	unsubscribe = url.unsubscribe,
	updateState = url.updateState;

export {
	back,
	decompose,
	forward,
	getHistories,
	getHistoriesIndex,
	getOrigin,
	getStateHash,
	getStatePath,
	getStateSearch,
	getStateType,
	parse,
	parseUrlHash,
	parseUrlPath,
	parseUrlSearch,
	pushState,
	pushStateHash,
	pushStateSearch,
	replaceState,
	replaceStateHash,
	replaceStateSearch,
	serializeState,
	serializeStateHash,
	serializeStatePath,
	serializeStateSearch,
	stateAction,
	stateActionMultitype,
	stateActionType,
	subscribe,
	unsubscribe,
	updateState
};

export default url;
